export class AddressValidateRequest {
  constructor(
    public firstName: string,
    public lastName: string,
    public companyName: string,
    public addressLine1: string,
    public addressLine2: string,
    public city: string,
    public stateCode: string,
    public postCode: string,
    public country: string,
    public email: string,
    public phone: string,
    public isBusiness: boolean,
    public stateTaxId: string,
    public registrationStateCode: string,
    public federalTaxId: string,
  ) {}
}
